// extracted by mini-css-extract-plugin
export default {"user":"user_user__OeeWi"};